<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="'User Details'"
  [nzTitle]="'User Details'"
  (nzBack)="goBack()"
>
</nz-page-header>
<div
  nz-row
  [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
  style="background-color: #eee"
>
  <div
    nz-col
    nzLg="4"
    nzMd="4"
    nzSm="24"
    nzXs="24"
    class="mt3"
    style="background-color: #eee"
  >
    <nz-card class="header text-center mb3">
      <div nz-row>
        <div
          nz-col
          nzLg="24"
          nzMd="24"
          nzSm="24"
          nzXs="24"
          class="userDetail"
          *ngIf="!userDetails && !userDetails.profilePicture"
        >
          <img
            src="../../assets/images/image.png"
            alt="Admin"
            class="rounded-circle"
            width="150"
          />
        </div>
        <div
          nz-col
          nzLg="24"
          nzMd="24"
          nzSm="24"
          nzXs="24"
          class="userDetail"
          *ngIf="userDetails && userDetails.profilePicture"
        >
          <img
            nz-image
            [nzSrc]="mediaBaseUrl + userDetails.profilePicture.path"
            alt="Admin"
            class="rounded-circle"
            width="150"
          />
        </div>
        <div
          nz-col
          nzLg="24"
          nzMd="24"
          nzSm="24"
          nzXs="24"
          class="mt-3 p3 userDetails-text"
        >
          <h2 class="user-color">
            <b>{{ userDetails.name }}</b>
          </h2>
        </div>
      </div>
    </nz-card>
  </div>
  <div nz-col nzLg="20" nzMd="20" nzSm="24" nzXs="24">
    <nz-card class="mt3 mb3 details-height">
      <!-- <h1 class="text-center">Details</h1> -->
      <div nz-row>
        <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
          <nz-form-label> Mail </nz-form-label>
          <p *ngIf="userDetails.email" class="details">
            <span nz-icon nzType="mail" nzTheme="outline"></span
            >{{ userDetails.email }}
          </p>
          <!-- <nz-divider *ngIf="!userDetails.email && !userDetails.mobile"></nz-divider> -->
          <nz-form-label> Phone No </nz-form-label>
          <p *ngIf="userDetails.mobile" class="details">
            <span nz-icon nzType="phone" nzTheme="outline"></span
            >{{ userDetails.mobile }}
          </p>
          <br *ngIf="!userDetails.mobile" />
          <br *ngIf="!userDetails.mobile" />
          <!-- <nz-divider *ngIf="!userDetails.mobile && !userDetails.dob"></nz-divider> -->
          <nz-form-label> Date Of Birth </nz-form-label>
          <p *ngIf="userDetails.dob" class="details">
            <span nz-icon nzType="calendar" nzTheme="outline"></span
            >{{ userDetails.dob | date: "dd/MM/yyyy" }}
          </p>
        </div>
        <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
          <nz-form-label> Gender </nz-form-label>
          <p *ngIf="userDetails.gender" class="details">
            <span nz-icon nzType="user" nzTheme="outline"></span
            >{{ userDetails.gender }}
          </p>
          <br *ngIf="!userDetails.gender" /><br *ngIf="!userDetails.gender" />
          <!-- <nz-divider
                        *ngIf="!userDetails.gender && !userDetails.line1 && !userDetails.line2 && !userDetails.city && !userDetails.state && !userDetails.pinCode"></nz-divider> -->
          <nz-form-label> Address </nz-form-label>
          <p
            *ngIf="
              userDetails.line1 &&
              userDetails.line2 &&
              userDetails.city &&
              userDetails.state &&
              userDetails.pinCode
            "
            class="details"
          >
            <span nz-icon nzType="home" nzTheme="outline"></span
            >{{ userDetails.line1 }}, {{ userDetails.line2 }},
            {{ userDetails.city }}, {{ userDetails.state }}, India, <br /><span
              >Pin Code:</span
            >
            {{ userDetails.pinCode }}
          </p>
        </div>
      </div>
    </nz-card>
  </div>
  <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
    <div nz-row>
      <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24" class="mt3 mb3">
        <!-- <nz-label><h2>Subscribe Test Series</h2></nz-label> -->
        <nz-form-label [nzSpan]="24" nzFor="description">
          <h3>Test conduct Details:</h3>
        </nz-form-label>
        <nz-table
          #userTbl
          [nzData]="allReport"
          [nzLoading]="loading"
          [nzTotal]="totalReportCount"
          [(nzPageSize)]="reportPageSize"
          [nzPageIndex]="reportPageIndex"
          [nzFrontPagination]="false"
          (nzQueryParams)="onQueryParamsChange($event)"
          nzTableLayout="fixed"
          nzBordered
          class="custom-report-table"
        >
          <thead>
            <tr>
              <th nzWidth="50px"></th>
              <th>Test Name</th>
              <th>Rank</th>
              <th>Correct Answers</th>
              <th>Attempted</th>
              <th>Time Spent</th>
              <th>Skipped</th>
              <th>Not Visited</th>
              <th>Percentile</th>
              <th>Total Questions</th>
              <th>Score</th>
              <th>Attended On</th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let data of allReport; let i = index">
              <tr class="table-row-hover">
                <!-- Expand Icon -->
                <td
                  [nzExpand]="isExpand && index === i"
                  (nzExpandChange)="onExpandChange(data._id, i, $event)"
                ></td>

                <!-- Test Name -->
                <td>
                  <b>{{ data.testName }}</b>
                </td>

                <!-- Rank -->
                <td>
                  <nz-tag nzColor="gold" *ngIf="data.rank">
                    🏆 {{ data.rank }}
                  </nz-tag>
                </td>

                <!-- Correct Answers -->
                <td>
                  <nz-tag nzColor="green">
                    {{ data.correct || 0 }} / {{ data.totalQuestion || 0 }}
                  </nz-tag>
                </td>

                <!-- Attempted -->
                <td>
                  <nz-tag nzColor="blue">
                    {{ data.attempted || 0 }} / {{ data.totalQuestion || 0 }}
                  </nz-tag>
                </td>

                <!-- Time Spent -->
                <td>
                  <nz-tag nzColor="orange">
                    {{ data.completedTime || 0 }} / {{ data.time || 0 }}
                  </nz-tag>
                </td>

                <!-- Skipped -->
                <td>
                  <nz-tag nzColor="volcano">{{ data.skipped || 0 }}</nz-tag>
                </td>

                <!-- Not Visited -->
                <td>
                  <nz-tag nzColor="purple">{{ data.unseenCount || 0 }}</nz-tag>
                </td>

                <!-- Percentile -->
                <td>
                  <nz-tag nzColor="cyan">
                    {{ getPercentile(data.percentile) }}%
                  </nz-tag>
                </td>

                <!-- Total Questions -->
                <td>
                  <b>{{ data.totalQuestion || 0 }}</b>
                </td>

                <!-- Score -->
                <td>
                  <nz-tag nzColor="green">
                    {{ data.finalMarks || 0 }} / {{ data.examTotalMarks || 0 }}
                  </nz-tag>
                </td>

                <!-- Attended On -->
                <td>
                  <span *ngIf="data.attendedAt">
                    {{ data.attendedAt | date: "dd MMM yyyy, h:mm a" }}
                  </span>
                </td>
              </tr>

              <!-- Expanded Row -->
              <tr [nzExpand]="isExpand && index === i">
                <!-- ✅ CASE 1: When extraData has items -->
                <ng-container
                  *ngIf="data?.extraData?.length > 0; else noDataBlock"
                >
                  <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 16, lg: 16 }">
                    <div
                      nz-col
                      nzLg="8"
                      nzMd="12"
                      nzSm="24"
                      nzXs="24"
                      *ngFor="let item of data.extraData"
                      class="mb3"
                    >
                      <nz-card
                        class="ml3 mt2"
                        [nzTitle]="item.name"
                        nzBordered="true"
                      >
                        <nz-descriptions
                          nzBordered
                          nzSize="small"
                          [nzColumn]="2"
                        >
                          <nz-descriptions-item nzTitle="Total Marks">
                            <nz-tag nzColor="green"
                              ><b>{{ item.finalmarks }}</b></nz-tag
                            >
                          </nz-descriptions-item>

                          <nz-descriptions-item nzTitle="Total Questions">
                            <nz-tag nzColor="blue"
                              ><b>{{ item.totalQuestions || 0 }}</b></nz-tag
                            >
                          </nz-descriptions-item>

                          <nz-descriptions-item nzTitle="Total Correct">
                            <nz-tag nzColor="green"
                              ><b>{{ item.correct }}</b></nz-tag
                            >
                          </nz-descriptions-item>

                          <nz-descriptions-item nzTitle="Total Wrong">
                            <nz-tag nzColor="red"
                              ><b>{{ item.inCorrect }}</b></nz-tag
                            >
                          </nz-descriptions-item>

                          <nz-descriptions-item nzTitle="Attempted">
                            <nz-tag nzColor="purple"
                              ><b>{{ item.attempted }}</b></nz-tag
                            >
                          </nz-descriptions-item>

                          <nz-descriptions-item nzTitle="Unattempted">
                            <nz-tag nzColor="volcano"
                              ><b>{{ item.unseenCount }}</b></nz-tag
                            >
                          </nz-descriptions-item>

                          <nz-descriptions-item nzTitle="Marks Obtained">
                            <nz-tag nzColor="green"
                              ><b>{{ item.totalMarksObtained || 0 }}</b></nz-tag
                            >
                          </nz-descriptions-item>

                          <nz-descriptions-item
                            nzTitle="Time Spent"
                            *ngIf="item.time"
                          >
                            <nz-tag nzColor="orange"
                              ><b>{{ item.time }}</b></nz-tag
                            >
                          </nz-descriptions-item>
                        </nz-descriptions>

                        <div class="mt3 text-center">
                          <b>Accuracy</b>
                          <nz-progress
                            [nzPercent]="
                              item.attempted + item.unseenCount
                                ? +(
                                    (item.correct /
                                      (item.attempted + item.unseenCount)) *
                                    100
                                  ).toFixed(2)
                                : 0
                            "
                            nzStatus="active"
                          >
                          </nz-progress>
                        </div>
                      </nz-card>
                    </div>
                  </div>
                </ng-container>

                <!-- ✅ CASE 2: No Extra Data -->
                <ng-template #noDataBlock>
                  <td colspan="10">
                    <nz-card class="no-data-card" nzBordered="true">
                      <div class="no-data-wrapper">
                        <span class="no-data-icon">📌</span>
                        <h3>No Detailed Report Found</h3>
                        <p>
                          This test has no additional analytics or section
                          details.
                        </p>
                      </div>
                    </nz-card>
                  </td>
                </ng-template>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>
      </div>
      <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24" class="mb3">
        <nz-form-label [nzSpan]="24" nzFor="description">
          <h3>Subscribe Test Series Details:</h3>
        </nz-form-label>
        <nz-table
          #userTbl
          [nzData]="allSUbscribeTestSeries"
          [nzLoading]="loading"
          [nzTotal]="totalSubscriptionCount"
          [(nzPageSize)]="subscriptionPageSize"
          [nzPageIndex]="subscriptionPageIndex"
          [nzFrontPagination]="false"
          nzShowSizeChanger
          (nzQueryParams)="onSubscribeTestSeriesPaginationChange($event)"
        >
          <thead>
            <tr>
              <th>Test-Series Name</th>
              <th>Plans Name</th>
              <th nzWidth="350px">Price (in ₹)</th>
              <!-- <th nzColumnKey="gender">Incorrect</th> -->
              <th nzWidth="350px">Time Duration(days)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of allSUbscribeTestSeries">
              <td *ngIf="data.testSeries">
                <nz-tag
                  *ngFor="let item of data.testSeries"
                  [nzColor]="getColorForItem(item)"
                  >{{ item.name }}</nz-tag
                >
              </td>
              <td>
                <span *ngIf="data.planName">{{ data.planName }}</span>
              </td>
              <td>
                <span *ngIf="data.totalAmount">
                  {{ "₹" + data.totalAmount || "₹" + 0 }}
                </span>
              </td>
              <td>
                <span>
                  {{ data.startDate | date: "dd/MM/yyyy" }} -
                  {{ data.endDate | date: "dd/MM/yyyy" }}
                </span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </div>
</div>
